import { useMemo } from 'react';
import {
  Avatar,
  Divider,
  Grid2 as Grid,
  Paper,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { Home, MapPin, MessageSquare, User as UserIcon } from 'lucide-react';
import Map, { Marker } from '@/components/map/Map';
import DataCell from '@/components/DataCell';
import { useUserProfile } from '@/hooks';
import { Order, User, AnonymousUser } from '@/types';

const OrderClientTab = (order: Order) => {
  const { palette } = useTheme();
  const { getUserById } = useUserProfile();

  const authClient = useMemo(
    () => getUserById(order?.client as string) as User,
    [getUserById, order?.client]
  );

  const anonClient = order.client;

  const client: AnonymousUser | User = authClient ?? anonClient;

  return (
    <>
      <Grid container spacing={2} alignContent="flex-start" height="100%">
        <Grid size={{ xs: 12, sm: 4 }}>
          <Stack spacing={2}>
            <Paper sx={{ width: '100%', p: 2 }}>
              <Stack
                justifyContent={'center'}
                alignItems={'center'}
                spacing={2}
                paddingTop={2}
              >
                {client?.image ? (
                  <Avatar
                    src={client.image}
                    alt="Foto de perfil del cliente"
                    sx={{ width: 100, height: 100 }}
                  />
                ) : (
                  <Avatar
                    sx={{
                      width: 100,
                      height: 100,
                      backgroundColor: palette.primary.light,
                    }}
                  >
                    <UserIcon
                      color={palette.primary.main}
                      strokeWidth={1}
                      width={50}
                      height={50}
                    />
                  </Avatar>
                )}
                {client?.name ? (
                  <Typography variant="h4" sx={{ textAlign: 'center' }}>
                    {client.name} {client?.lastname ?? ''}
                  </Typography>
                ) : null}
                <Divider />
              </Stack>
            </Paper>
            <Paper sx={{ width: '100%', p: 2 }}>
              <Stack direction={'row'} spacing={2} alignItems={'center'}>
                <MessageSquare color={palette.primary.main} />
                <DataCell
                  vertical
                  label="Whatsapp"
                  value={String(client?.phone ? client.phone : '-')}
                />
              </Stack>
            </Paper>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, sm: 8 }}>
          <Paper
            sx={{
              width: '100%',
            }}
          >
            <Stack spacing={2}>
              <Stack
                direction={'row'}
                spacing={2}
                alignItems={'center'}
                px={2}
                pt={2}
              >
                <MapPin color={palette.primary.main} />
                <DataCell
                  vertical
                  label="Barrio"
                  value={order.deliveryLocation?.neighborhood}
                />
              </Stack>
              <Stack direction={'row'} spacing={2} alignItems={'center'} px={2}>
                <Home color={palette.primary.main} />
                <DataCell
                  vertical
                  label="No. de Casa"
                  value={order.deliveryLocation?.house}
                />
              </Stack>
              <Map height={'370px'} type="roadmap">
                <Marker
                  lat={order.deliveryLocation?.latitude ?? ''}
                  lng={order.deliveryLocation?.longitude ?? ''}
                />
              </Map>
              <Stack p={2} pt={0}>
                <DataCell
                  vertical
                  label="Dirección / Cómo llegar:"
                  value={order.deliveryLocation?.address}
                />
              </Stack>
            </Stack>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

export default OrderClientTab;
